"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SsoRegistrationTelephoneResponseDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class SsoRegistrationTelephoneResponseDto {}
exports.SsoRegistrationTelephoneResponseDto = SsoRegistrationTelephoneResponseDto;
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.SsoRegistrationTelephoneFlow
}), __metadata("design:type", String)], SsoRegistrationTelephoneResponseDto.prototype, "flow", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], SsoRegistrationTelephoneResponseDto.prototype, "message", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Present in non-production for dummy telephone numbers when flow is OtpSent.'
}), __metadata("design:type", String)], SsoRegistrationTelephoneResponseDto.prototype, "otp", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Short-lived token used with POST /auth/identity/conflict/resolve when flow is AccountConflict.'
}), __metadata("design:type", String)], SsoRegistrationTelephoneResponseDto.prototype, "conflictToken", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.AccountIdentityConflictReason,
  required: false
}), __metadata("design:type", String)], SsoRegistrationTelephoneResponseDto.prototype, "conflictReason", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.IdentityProvider,
  isArray: true,
  required: false,
  description: 'Sign-in methods available on the existing account to prove ownership.'
}), __metadata("design:type", Array)], SsoRegistrationTelephoneResponseDto.prototype, "availableProviders", void 0);
//# sourceMappingURL=SsoRegistrationTelephoneResponse.dto.js.map